import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { CLP_TYPE, PLP_TYPE } from '@yme/common/constants';
import { useDispatch } from '@yme/hooks/useDispatch';
import { setPrevGroupingProductSku, setPrevPageType, getPrevGroupingProductSku, getPrevPageType, } from '@yme/pdp-components/ProductCard';
import { getPageType } from '@yme/selectors/common';
import { getProductFullPowerYAMTSku } from '@yme/selectors/products';
export const useTransmission = () => {
    const [isTransmission, setIsTransmission] = useState(false);
    const productFullPowerATMTSku = useSelector(getProductFullPowerYAMTSku);
    const pageType = useSelector(getPageType);
    const prevPageType = useSelector(getPrevPageType);
    const prevGroupingProductSku = useSelector(getPrevGroupingProductSku);
    const dispatch = useDispatch();
    useEffect(() => {
        if (!productFullPowerATMTSku) {
            dispatch(setPrevGroupingProductSku(''));
        }
        return () => {
            dispatch(setPrevGroupingProductSku(''));
        };
    }, [dispatch, productFullPowerATMTSku]);
    useEffect(() => {
        const isNewProduct = prevGroupingProductSku !== productFullPowerATMTSku;
        const isRedirectFromListingPage = prevPageType === CLP_TYPE || prevPageType === PLP_TYPE;
        if (isRedirectFromListingPage && productFullPowerATMTSku) {
            dispatch(setPrevPageType(pageType));
            window.location.hash = productFullPowerATMTSku;
            dispatch(setPrevGroupingProductSku(productFullPowerATMTSku));
        }
        const hash = window.location.hash;
        if (hash === '' && productFullPowerATMTSku && isNewProduct) {
            window.location.hash = productFullPowerATMTSku;
            dispatch(setPrevGroupingProductSku(productFullPowerATMTSku));
        }
        setIsTransmission(true);
    }, [dispatch, pageType, prevGroupingProductSku, prevPageType, productFullPowerATMTSku]);
    return {
        isTransmission,
    };
};
